import styled from 'styled-components/macro';

export const Gap = styled.div<{
  gap?: string;
  center?: boolean;
  m?: string;
  direction?: string;
}>`
  display: flex;
  margin: ${({ m }) => m || '0px'};
  gap: ${({ gap }) => gap || '16px'};
  flex-direction: ${({ direction }) => direction || 'row'};
`;
